import { A } from '@adornis/base/env-info.js';
import type { RegistrationStammdatenPlugin } from '@adornis/buchungsheld-db/db-plugins.js';
import { UserStammdaten } from '@adornis/buchungsheld-db/entities/stammdaten.js';

export const defaultRegistrationStammdatenPlugin: RegistrationStammdatenPlugin = {
  id: 'registration::stammdaten::default',
  type: 'registration::stammdaten',
  disableCustomFormfields: false,
  createStammdaten: async ({ userID, institutionID, createInDB } = {}) => {
    const data = new UserStammdaten({ _id: A.getGloballyUniqueID(), userID, institutionID });

    if (createInDB) await data.create();
    return data;
  },
  getFields: (institutionID: string) => {
    const fields = UserStammdaten.fields;
    return Object.keys(fields).map(key => fields[key]!.name);
  },
  classType: () => UserStammdaten,
};
